import React from 'react';
import { View } from 'react-native';
import ShellViewState from './ShellViewState';
import ShellViewProps from './ShellViewProps';
import ShellViewStyle from './ShellViewStyle';
import ShellViewModel from './ShellViewModel';
import { Switch, Route } from 'react-router';
import { ContentView, Application, NavigationManager, Managers, LanguageManager } from '@levelapp/softfabric';
import DetailsView from './modules/details/DetailsView';
import InvestFlowView from "./modules/investflow/InvestFlowView";
import { WindowSizeProvider } from "../Common/contexts/WindowSizeContext";
import CompleteAccountView from './modules/completeAccount/CompleteAccountView';

export default class ShellView extends ContentView<ShellViewProps, ShellViewState, ShellViewModel, ShellViewStyle> {
  NavigationManager: NavigationManager = Application.current.resolve<NavigationManager>(Managers.NAVIGATION_MANAGER);
  LanguageManager: LanguageManager = Application.current.resolve<LanguageManager>(Managers.LANGUAGE_MANAGER);

  /* CONSTRUCTOR */
  constructor(props: ShellViewProps) {
    super(props);

    // Binding
    this.bind(new ShellViewModel(this), new ShellViewStyle(this));
  }

  /* RENDERING */
  render() {
    return (
        <View style={this.style.shell}>
          <WindowSizeProvider>
            <Switch>
              <Route path="/:language/completeAccount" render={() => <CompleteAccountView />} />
              <Route path="/:language/details/:code" render={(props) => <DetailsView code={props.match.params.code} />} />
              <Route path="/:language/invest/:code" render={(props) => <InvestFlowView code={props.match.params.code} />} />
            </Switch>
          </WindowSizeProvider>
        </View>
    )
  }
}